import React, { useEffect, useState } from "react";
import cn from "classnames";
import { func } from "../../../utils";
import Text from "../Text";
import PropTypes from "prop-types";
import Button from "../Button";
import { useLocation, useNavigate } from "react-router-dom";
import { isLiveStreamingDate, scrollTo } from "../../../utils/function";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import analytics from "../../../utils/analytics";
import useWindowSize from "../../../hooks/useWindowSize";
import { useStore } from "zustand";
import { useUserData } from "../../../store/user";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/registration/`;

const NavBar = ({ menus, className, pageType, isShowBurger = true }) => {
  const { size } = useWindowSize();
  const isUserRegisteredPage = pageType === "registered-user";
  console.log({ pageType });
  const isSmallScreen = (size?.height || 0) <= 667;
  const isMobileView = (size?.width || 0) <= 768;
  const [offset, setOffset] = useState(0);
  const [offset2, setOffset2] = useState(0);
  const [navBlur, setNavBlur] = useState(false);
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);
  const { city, idInView, isLive, videoUrl, isRegist, registrationUrl } =
    usePageContextState();

  const { registrationData } = useUserData();
  const { setIdInView } = usePageContextFunction();
  const navigate = useNavigate();
  const location = useLocation();
  const { accessToken } = useUserData();
  const eventCategoryId = registrationData?.event_category_id;
  const isDanceCategory = eventCategoryId === 3;
  const imgLogo = isDanceCategory
    ? func.getStaticImg("illustration/piala-byU-2025.png")
    : `${imgPath}${registrationData?.school_logo}`;

  const sections = document.querySelectorAll("section");
  const navLi = document.querySelectorAll(".navbar__container__inner__text");
  const isNavOffset = offset > 0;
  const navOffSetExclusion = idInView === "hall-of-fame" && isNavOffset;
  const rootUrl =
    idInView === "rsvp"
      ? "https://pialabyu.com/rsvp"
      : city && city !== "press-con"
      ? `https://pialabyu.com/${city}`
      : "https://pialabyu.com";
  const classNames = cn("navbar__container", className, {
    navbar__container__scroll: idInView !== "slick-scroll" && isNavOffset,
    navbar__container__scroll__dynamicHighlight: navOffSetExclusion,
    "!z-[20]": isUserRegisteredPage,
  });
  const isSocSection = city === "soc" || idInView === "rsvp" || city;

  const footerLandingId = !isSocSection
    ? "footer-landing"
    : "footer-landing-soc";
  const infoLokasiId = !isSocSection ? "info-lokasi" : "info-lokasi-soc";
  const classNamesBurger = cn("navbar__burger-menu__bar", {
    // "navbar__burger-menu__bar__solid":
    //   [
    //     "event",
    //     footerLandingId,
    //     "journey",
    //     "jadwal-pertandingan",
    //     "klasemen-pertandingan",
    //     infoLokasiId,

    //     "sponsor",
    //   ].includes(idInView) && !isNavOffset,
    "navbar__burger-menu__bar__solid-black":
      ["event", footerLandingId, "journey", "sponsor"].includes(idInView) ||
      (isNavOffset &&
        idInView !== "hall-of-fame" &&
        infoLokasiId !== "info-lokasi-soc") ||
      isUserRegisteredPage,
    "navbar__burger-menu__bar__onOpen": showNavigationMenu,
  });

  const classNamesNavbar = cn(
    "navbar__container__inner",
    {
      navbar__container__inner__shadow:
        location.pathname === "/" &&
        location.pathname === "/pembayaran" &&
        [footerLandingId, "journey"].includes(idInView),
    },
    "md:pr-[2vw] md:pl-[10vw] pr-[2vw] pl-[5vw]"
  );

  const { pathname } = useLocation();
  const isLoginPage = pathname.includes("login");
  const isGalleryPage = pathname.includes("gallery");
  const isLogin = !!accessToken;

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const rootBody = document.getElementById("root-body");
    if (city === "soc" || city === "press-con") {
      rootBody.style.backgroundColor = "#2e4261";
    } else {
      rootBody.style.backgroundColor = ""; // Reset to default
    }
  }, [city]);
  useEffect(() => {
    document.querySelector(".box-wrapper")?.addEventListener(
      "scroll",
      (e) => {
        if (
          (idInView === "timeline-soc" ||
            idInView === "hall-of-fame" ||
            idInView === "sponsor-soc" ||
            idInView === "footer-landing" ||
            infoLokasiId === "info-lokasi-soc") &&
          isMobileView
        ) {
          let st = Math.ceil(e.currentTarget.scrollTop * 100) / 100;
          //console.log({ st, offset2: offset2 + 0.5 });
          if (st === offset2 + 0.5) {
            setNavBlur(false);
            // downscroll code
          } else {
            setNavBlur(true);
          } // else was horizontal scroll
          setOffset2(st <= 0 ? 0 : st);

          //  const scrollPosition = e.currentTarget.scrollTop;

          // if (offset <= Math.round(scrollPosition * 100) / 100 && !navBlur) {
          //   setNavBlur(true);
          //   setOffset(
          //     Math.round(scrollPosition * 100) / 100 -
          //       Math.round(window.innerHeight)
          //   );
          // } else if (offset > Math.round(scrollPosition * 100) / 100) {
          //   setNavBlur(false);
          // }
        } else {
          setNavBlur(false);
          setOffset2(0);
        }
      },
      false
    );
  }, [idInView, offset2]);

  useEffect(() => {
    // showNavigationMenu (Mobile Menu)

    if (showNavigationMenu) {
      document.body.classList.add("show-navigation");
      document.body.classList.add("rm-scroll");
    } else {
      document.body.classList.remove("show-navigation");
      document.body.classList.remove("rm-scroll");
    }
  }, [showNavigationMenu]);
  // window.onscroll = () => {
  //   let current = "";
  //   sections.forEach((section) => {
  //     const sectionTop = section.offsetTop;
  //     const sectionHeight = section.offsetHeight;

  //     if (window.pageYOffset >= sectionTop - sectionHeight / 2) {
  //       current = section.getAttribute("id");
  //     }
  //   });

  //   navLi.forEach((div) => {
  //     div.classList.remove("navbar__container__inner__text__active");

  //     if (div.classList.contains(current)) {
  //       div.classList.add("navbar__container__inner__text__active");
  //     }
  //   });
  // };
  const handleNavigationMenu = () => {
    setShowNavigationMenu(!showNavigationMenu);
  };

  const isSubMenu = location.pathname?.split("/")?.length > 2;
  console.log({ idInView });
  const getStyles = () => {
    // if (isSubMenu && !location.pathname.includes("info-lomba")) {
    //   return {
    //     backgroundColor: "#00BCF1",
    //     imgByu: func.getStaticImg(`illustration/byU-logo.svg`),
    //   };
    // }

    if (
      (idInView === "event" ||
        idInView === footerLandingId ||
        idInView === "journey" ||
        idInView === "timeline" ||
        idInView === "sponsor" ||
        isNavOffset) &&
      idInView !== "hall-of-fame"
    ) {
      const offCond =
        (idInView === "event" ||
          idInView === footerLandingId ||
          idInView === "sponsor" ||
          isNavOffset) &&
        !navBlur &&
        infoLokasiId !== "info-lokasi-soc";
      return {
        backgroundColor: offCond ? "white" : "#0397C9",
        imgByu: func.getStaticImg(
          offCond
            ? "illustration/byu-logo-blue.svg"
            : `illustration/byU-logo.svg`
        ),
        position: idInView === "timeline" ? "absolute" : "inherit",
        loginbtn: "primary-white",
        iconLogin: isMobileView ? "white" : "black",
        invertNavbar: offCond && !isMobileView,
        burgerMenuClassName: classNamesBurger,
      };
    } else if (
      idInView?.includes("jadwal-pertandingan") ||
      idInView?.includes("klasemen-pertandingan") ||
      idInView?.includes("info-lokasi")
    ) {
      const isSocNav =
        isMobileView && idInView == "info-lokasi" && city === "soc";

      return {
        backgroundColor: "transparent",
        burgerMenuClassName: classNamesBurger,
        imgByu: func.getStaticImg(
          isNavOffset || infoLokasiId === "info-lokasi-soc"
            ? `illustration/byU-logo.svg`
            : `illustration/byu-logo-blue.svg`
        ),
        position: infoLokasiId === "info-lokasi-soc" ? "relative" : "inherit",
        invertNavbar: city ? false : !isMobileView,
        loginbtn: "primary-white",
        iconLogin: isMobileView ? "white" : "black",
      };
    } else {
      return {
        backgroundColor: "transparent",
        imgByu: func.getStaticImg(`illustration/byU-logo.svg`),
        burgerMenuClassName: classNamesBurger,
        position: "absolute",
        loginbtn: "secondary-white",
        iconLogin: "white",
        //   invertNavbar: true,
      };
    }
  };

  const renderNav = () => {
    return (
      <div className="o-header__nav hideOnMobile">
        <ul
          className="o-header__menu"
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginLeft: "2.4rem",
            marginBottom: "1rem",
          }}
        >
          {menus.map((menu, idx) => {
            const exclutionConditional =
              (menu?.link === "perjalanan-pialabyu" && idInView === "event") ||
              (menu?.link === "announce" && idInView === "banner");

            const isPageActive =
              pageType === "landing-page" ||
              (pageType === "press-con" && city === "press-con")
                ? menu?.link === idInView || exclutionConditional
                : menu?.link === location.pathname;

            const classNameNavItem = cn(
              "navbar__container__inner__text",

              menu?.link,
              {
                // navbar__container__inner__text__active: false,
                navbar__container__inner__text__active:
                  isPageActive && !getStyles()?.invertNavbar,
                navbar__container__inner__text__invert:
                  isPageActive && getStyles()?.invertNavbar,
              }
            );

            return (
              <span
                key={`mmi-${idx}`}
                className={"navbar__menu__item"}
                style={{ margin: "0px 16px 0px 16px" }}
                onClick={async () => {
                  if (
                    pageType === "landing-page" ||
                    (pageType === "press-con" && city === "press-con")
                  ) {
                    if (menu?.link === "announce") {
                      const element = document.getElementById("announce");
                      element.scrollIntoView(false);
                    } else {
                      if (
                        menu?.link !== "footer-landing" &&
                        !menu?.anotherPage
                      ) {
                        await setIdInView(menu?.link);
                      } else {
                        if (menu?.anotherPage) {
                          navigate(menu?.link ?? "/");
                        }
                      }
                      func.scrollTo(menu?.link);
                    }
                  } else {
                    if (menu?.link === "external") {
                      menu?.onClick?.();
                    } else {
                      console.log("menu", menu?.link);
                      navigate(menu?.link ?? "/");
                    }
                  }
                  setShowNavigationMenu(false);
                }}
              >
                {/* <Link href={menu?.link}> */}
                <a
                  //  href={menu?.link}
                  className="navbar__menu__link"
                  style={{ textDecoration: "none" }}
                >
                  <Text
                    className={classNameNavItem}
                    weight="bold"
                    size="medium"
                    color={getStyles()?.invertNavbar ? "primary" : "white"}
                  >
                    {menu?.label}
                  </Text>
                </a>
                {/* </Link> */}
              </span>
            );
          })}
        </ul>
      </div>
    );
  };
  console.log({ city });
  return (
    <>
      <div
        className={cn(
          classNames,
          (navBlur && isMobileView && idInView !== "banner") ||
            (idInView === "info-lokasi" &&
              infoLokasiId === "info-lokasi-soc" &&
              idInView !== "banner") ||
            ((city === "press-con" || city) && offset) ||
            ((idInView === "jadwal-pertandingan" ||
              idInView === "klasemen-pertandingan") &&
              idInView !== "banner")
            ? "!bg-[#1f2d3d60] bg-blur-md top-0 !z-[100]"
            : idInView === "rsvp"
            ? " bg-blur-md top-0"
            : isMobileView && !navBlur && infoLokasiId === "info-lokasi-soc"
            ? "!bg-transparent"
            : ""
        )}
        style={
          isUserRegisteredPage
            ? {
                height: 64,
                top: 0,
                backgroundColor: "white",
              }
            : offset <= 0
            ? {
                position: getStyles()?.position,
                height: 64,
                background: getStyles()?.background,
                backgroundRepeat: getStyles()?.backgroundRepeat,
                backgroundColor: isLogin
                  ? "transparent"
                  : getStyles()?.backgroundColor,
                top:
                  idInView === "banner" ||
                  idInView === "timeline-presscon" ||
                  idInView !== "banner-section2" ||
                  idInView === "home-detail-banner" ||
                  idInView === "home-detail-content" ||
                  idInView === "home-detail-content-01" ||
                  idInView === "home-detail-content-02" ||
                  idInView === "banner-section2"
                    ? isMobileView
                      ? 25
                      : 30
                    : getStyles()?.backgroundColor !== "transparent"
                    ? 0
                    : 0,
                // height: isSmallScreen ? 64 : 88,
              }
            : { height: 64 }
        }
      >
        {isLoginPage ? (
          <div className={classNamesNavbar}>
            <img
              className={"navbar__container__m-button--icon"}
              src={func.getStaticImg(`icon/sa-arrow-left.svg`)}
              alt={"login-icon"}
              height={24}
              width={24}
              onClick={() => navigate(-1)}
            />
          </div>
        ) : (
          <div className={classNamesNavbar}>
            {isLogin && showNavigationMenu ? (
              <div
                className={`z-[12] flex items-center gap-2  transition-opacity ease-in duration-700 ${
                  showNavigationMenu ? "opacity-100" : "opacity-0"
                }`}
              >
                <img
                  src={imgLogo}
                  alt={`school-logo`}
                  onClick={() => navigate("/")}
                  className={`w-auto h-[28px] navbar__container__byu-logo transition-opacity ease-in duration-700 ${
                    showNavigationMenu ? "opacity-100" : "opacity-0"
                  }`}
                />
                <span
                  className={`text-white font-bold text-[16px]  transition-opacity ease-in duration-700 ${
                    showNavigationMenu ? "opacity-100" : "opacity-0"
                  }`}
                >
                  {registrationData?.school_name || "-"}
                </span>
              </div>
            ) : (location.pathname !== "/" &&
                location.pathname !== "/pembayaran") ||
              (location.pathname !== "/main" && !isLogin) ? (
              <img
                onClick={() => (window.location.href = rootUrl)}
                src={getStyles()?.imgByu}
                alt={`byU-logo`}
                className={`navbar__container__byu-logo`}
              />
            ) : null}

            <div
              className={cn(
                "navbar__container__inner__wrapper--text navbar__nav",
                isSocSection ? "bg-[#1F2D3D] h-[100vh]" : ""
              )}
            >
              {menus.map((menu, i) => {
                const exclutionConditional =
                  (menu?.link === "perjalanan-pialabyu" &&
                    idInView === "event") ||
                  (menu?.link === "announce" && idInView === "banner");
                const isPageActive =
                  pageType === "landing-page" ||
                  (pageType === "press-con" && city === "press-con")
                    ? menu?.link === idInView || exclutionConditional
                    : menu?.link === location.pathname;
                const classNameNavItem = cn(
                  "navbar__container__inner__text",
                  "navbar__link",
                  "navbar__item",
                  menu?.link,
                  {
                    // navbar__container__inner__text__active: false,
                    navbar__container__inner__text__active:
                      isPageActive && !getStyles()?.invertNavbar,
                    navbar__container__inner__text__invert:
                      isPageActive && getStyles()?.invertNavbar,
                  }
                );

                if (menu?.hideMenu) return;

                return (
                  <span
                    key={i}
                    onClick={async () => {
                      const payload = {
                        event: `menuClickPiala_${
                          city ?? analytics.defaultCity
                        }`,
                        menu_name: menu?.label,
                      };

                      const whiteListedNav = ["landing-page", "press-con"];
                      console.log({ pageType, city });
                      if (whiteListedNav?.includes(pageType)) {
                        if (menu?.link === "announce") {
                          const element = document.getElementById("announce");
                          element.scrollIntoView(false);
                        } else {
                          if (
                            menu?.link !== "footer-landing" &&
                            !menu?.anotherPage
                          ) {
                            city === "press-con"
                              ? await setIdInView(menu?.link)
                              : navigate(menu?.link ?? "/");
                          } else {
                            if (menu?.anotherPage) {
                              navigate(menu?.link ?? "/");
                            }
                            func.scrollTo(menu?.link);
                          }
                          func.scrollTo(menu?.link);
                        }
                      }
                      // navigate(menu?.link ?? "/");

                      setShowNavigationMenu(false);
                    }}
                  >
                    <Text
                      className={classNameNavItem}
                      weight="bold"
                      size="medium"
                      color="white"
                    >
                      {menu?.label}
                    </Text>
                  </span>
                );
              })}

              {!isLogin && pageType !== "registered-user" ? (
                <button
                  className={cn("button-login", isSocSection ? "hidden" : "")}
                  onClick={() => {
                    navigate("/login");
                    setShowNavigationMenu(false);
                  }}
                >
                  <img
                    src={func.getStaticImg(`icon/credential.svg`)}
                    alt={"login-icon"}
                    className={"navbar__container__m-button--icon"}
                    height={16}
                    width={16}
                  />
                  <span style={{ marginLeft: "8px" }}>Login</span>
                </button>
              ) : (
                <button
                  className="button-logout"
                  onClick={() => {
                    localStorage.clear();
                    window.location.reload();
                    window.location.href = "/";
                  }}
                >
                  <img
                    src={func.getStaticImg(`icon/sa-logout.svg`)}
                    alt={"logout-icon"}
                    className={"navbar__container__m-button--icon"}
                    id="logout-icon"
                    height={16}
                    width={16}
                  />
                  <span style={{ marginLeft: "8px" }}>Logout</span>
                </button>
              )}
            </div>

            {(idInView?.includes("home-detail") || isSocSection) &&
              isLive &&
              isMobileView && (
                <Button
                  className={"navbar__container__m-button--ticket w-[163px]"}
                  variant={"primary-red"}
                  size={"small"}
                  onClick={() => window.open(videoUrl, "_blank")}
                >
                  <img
                    src={func.getStaticImg(`icon/live-streaming.svg`)}
                    alt={"streaming-icon"}
                    className={"navbar__container__m-button--icon mr-2"}
                  />
                  <span className="text-[14px]">LIVE STREAMING</span>
                </Button>
              )}

            {renderNav()}
            {/* 
          {idInView?.includes("home-detail") &&
            isLive &&
            !isMobileView &&
            !isShowBurger && (
              <Button
                className={"navbar__container__d-button--ticket"}
                variant={"primary-red"}
                size={"small"}
                onClick={() => window.open(videoUrl, "_blank")}
              >
                <img
                  src={func.getStaticImg(`icon/live-streaming.svg`)}
                  alt={"streaming-icon"}
                  className={"navbar__container__m-button--icon"}
                />
                <span style={{ marginLeft: "8px" }}>LIVE STREAMING</span>
              </Button>
            )} */}
            {(idInView?.includes("home-detail") || isSocSection) &&
              isLive &&
              !isMobileView &&
              !isShowBurger && (
                <Button
                  className={"navbar__container__d-button--ticket"}
                  variant={"primary-red"}
                  size={"small"}
                  onClick={() => window.open(videoUrl, "_blank")}
                >
                  <img
                    src={func.getStaticImg(`icon/live-streaming.svg`)}
                    alt={"streaming-icon"}
                    className={"navbar__container__m-button--icon"}
                  />
                  <span style={{ marginLeft: "8px" }}>LIVE STREAMING</span>
                </Button>
              )}
            {!isMobileView && !isShowBurger && !isLogin ? (
              <Button
                className={cn(
                  "navbar__container__d-button--ticket button-icon-login"
                )}
                variant={getStyles()?.loginbtn}
                size={"small"}
                onClick={() => {
                  navigate("/login");
                  setShowNavigationMenu(false);
                }}
              >
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  <img
                    src={func.getStaticImg(
                      `icon/credential-${getStyles()?.iconLogin}.svg`
                    )}
                    alt={"login-icon"}
                    className={"navbar__container__m-button--icon icon-login"}
                    height={16}
                    width={16}
                    style={{ marginRight: 8 }}
                  />
                  Login
                </span>
              </Button>
            ) : isLogin ? (
              <div
                className={`md:mr-[10%] mr-4 flex align-middle items-center gap-2 ${
                  location.pathname !== "/" &&
                  location.pathname !== "/pembayaran"
                    ? "ml-auto"
                    : "ml-0"
                }`}
              >
                <img
                  src={imgLogo}
                  alt={`school-logo`}
                  onClick={() => navigate("/")}
                  className={"h-[28px] w-[28px] navbar__container__byu-logo"}
                />

                {(location.pathname === "/" ||
                  location.pathname === "/pembayaran" ||
                  (location.pathname === "/main" && !isMobileView)) && (
                  <span
                    className={`font-bold text-[16px] truncate max-w-[128px] ${
                      location.pathname !== "/" &&
                      location.pathname !== "/pembayaran"
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {registrationData?.school_name || "-"}
                  </span>
                )}
              </div>
            ) : (
              <img
                src={func.getStaticImg(
                  `icon/credential-${getStyles()?.iconLogin}.svg`
                )}
                alt={"login-icon"}
                onClick={() => {
                  navigate("/login");
                  setShowNavigationMenu(false);
                }}
                className={cn(
                  "h-[24px] w-[24px]  navbar__container__byu-logo ml-auto md:mr-[10%] mr-4"
                )}
              />
            )}

            {/* button pendaftaran */}
            {/* {idInView?.includes("home-detail") &&
            isRegist &&
            !isMobileView &&
            !isShowBurger && (
              <Button
                className={"navbar__container__d-button--ticket"}
                variant={"primary-orange"}
                size={"small"}
                onClick={() => window.open(registrationUrl, "_blank")}
              >
                <span style={{ marginLeft: "8px" }}>PENDAFTARAN</span>
              </Button>
            )} */}

            {isShowBurger && !isGalleryPage && idInView !== "rsvp" && (
              <button
                className="navbar__burger-menu"
                type="button"
                onClick={handleNavigationMenu}
              >
                <span className={classNamesBurger}></span>
                <span className={classNamesBurger}></span>
                <span className={classNamesBurger}></span>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

NavBar.propTypes = {
  menus: PropTypes.array,
  className: PropTypes.string,
};

NavBar.defaultProps = {
  menus: "",
  className: "",
};

export default NavBar;
